import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar.jsx'
import Footer from '../components/Footer.jsx'
import PropTypes from 'prop-types'
import '../styles/AppLayout.css'

const AppLayout = ({ userRole }) => {
  return (
    <>
      {userRole ? (
        <div className="app-layout">
          <Navbar userRole={userRole} />
          <div className="content-container">
            <div className="content">
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      ) : (
        <Outlet />
      )}
    </>
  )
}

AppLayout.propTypes = {
  userRole: PropTypes.string,
}

export default AppLayout
